// extracted by mini-css-extract-plugin
export default {"container":"style__container___shZbv","title":"style__title___CmYXk","subtitle":"style__subtitle___Ftz9E","or":"style__or___cJC7r"};